import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-oi-rating-bar',
  template: `
    <p>
      oi-rating-bar works!
    </p>
  `,
  styles: [
  ]
})
export class OiRatingBarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
